import requests from './httpService';

const CursiveMasterService = {
  getAllCursiveMaster(body) {
    return requests.post(`/cursivemaster/list`, body);
  },
  
  findCursiveMasterList(body) {
    return requests.post(`/cursivemaster/find`, body);
  },
  
  createCursiveMaster(body) {
    return requests.post('/cursivemaster/add', body);
  },
  
  getCursiveMasterById(id) {
    return requests.get(`/cursivemaster/${id}`);
  },
  
  updateCursiveMaster(id, body) {
    return requests.put(`/cursivemaster/${id}`, body);
  },
  
  deleteCursiveMaster(id) {
    return requests.delete(`/cursivemaster/${id}`);
  },
};

export default CursiveMasterService;

